import http from './http'
import { Res } from './type'

export interface WatermarkConfig {
  isWatermark?: number
  showUserName?: boolean
  showUserUsername?: boolean
  showUserCode?: boolean
  showDate?: boolean
  showDeptName?: boolean
  showPostName?: boolean
}

export function fetchWatermarkConfig(params?: any): Res<WatermarkConfig> {
  return http.request({
    url: '/sands-user/api/v1/enterprise/getWatermark',
    method: 'get',
    params,
    loadingShow: '0'
  })
}
